import { useTranslation } from 'next-i18next'
import { RecentCommenterInterface } from 'modules/community/types/post-info'

interface CommentAuthorPreviewProps {
  author: RecentCommenterInterface
}

const DEFAULT_AUTHOR_AVATAR = `/default_post_author_avatar.webp`

export default function CommentAuthorPreview({ author }: CommentAuthorPreviewProps) {
  const { t } = useTranslation()

  return (
    <img
      title={t('community.post_announce.post_info.avatar.title', { name: author.displayName })}
      alt={t('community.post_announce.post_info.avatar.alt', { name: author.displayName })}
      src={author.avatarUrl || DEFAULT_AUTHOR_AVATAR}
      className="size-6 rounded-full"
    />
  )
}
